// extracted by mini-css-extract-plugin
export default {"printing":"Printing_printing__QBSTF"};